export enum Grid {
    Customer = 1,
    JobSite = 2,
    WorkOrder = 3,
    WorkOrderReview = 4,
    JobSiteEquipment = 5,
    ServiceAgreement = 6,
    Product = 7,
    Category = 8,
    Setup = 9,
    AccountingLog = 10,
    TaxGroup = 11,
    DispatchBoard = 12,
    CustomerSearch = 13,
    JobsiteSearch = 14,
    CustomerLiteSearch = 15,
    NewWorkOrder = 16,
    JobSiteWorkOrder = 17,
    JobSiteServiceAgreement = 18,
    Visit = 19,
    JobSiteVisit = 20,
    Estimate = 21,
    JobSiteEstimate = 22
}
